// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal--n_Khi","form":"form--Rz7q3","title":"title--I_TOa"};